module.exports = __webpack_public_path__ + "static/media/9.39ec87db.jpg";